import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { ITrainingForm, Table } from "./Table";
import { Form } from "./Form";
import { IPermissionProps } from "../../../models/Login";

export const TrainingFormSubmission = (permission: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as { open: boolean, singleData: ITrainingForm });
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => setModal({ singleData: {}, open: false });
    const reloadTable = () => setReload(!reload);
    return (
        <>
            {(permission.is_Create || permission.is_Update) && <Form open={modal.open} singleData={modal.singleData} hideDialog={() => hideDialog()} toast={toast} reloadTable={() => reloadTable()} />}
            <Table setModal={setModal} reload={reload} permission={permission} toast={toast} reloadTable={() => reloadTable()} />
            <Toast ref={toast} />
        </>
    );
}